import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#477491',
    },
    secondary: {
      main: '#D28415',
    },
    background: {
      default: '#FAF7F2',
    },
  },
  typography: {
    fontFamily: '"Patrick Hand", Arial, sans-serif',
  },
  shape: {
    borderRadius: 12,  // Rounded corners
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          minHeight: 38,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: '1rem', // Prevents iOS Safari zoom-in on focus
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          WebkitTapHighlightColor: 'transparent',
        },
      },
    },
  },
});

export default theme;